import React from 'react';
import { UtpCardSection } from 'common/components';
import { KITCHEN_ELEMENT_BLOCK } from '../../../kitchen-constants';
import { KITCHEN_DESIGN_CARD_LIST } from './kitchen-design-section-constants';

type KitchenDesignSectionProps = {
  regionId: string;
};

export const KitchenDesignSection = ({ regionId }: KitchenDesignSectionProps) => (
  <UtpCardSection
    isNewAnalytics
    elementBlock={KITCHEN_ELEMENT_BLOCK}
    elementText="Закажите кухню в&nbsp;Лемана&nbsp;ПРО"
    renderModalContent={({ modal: { content: ModalContent } = {} }) =>
      ModalContent && <ModalContent regionId={regionId} />
    }
    title="Закажите кухню в&nbsp;Лемана&nbsp;ПРО"
    utpCardList={KITCHEN_DESIGN_CARD_LIST}
  />
);
